import { toastService as toast } from "../components/ui/toast/toast.service";

const agent = navigator.userAgent.toLowerCase();

const detectBrowser = (): string => {
    if (agent.includes("edg/")) return "Edge (chromium based)";
    if (agent.includes("edge")) return "MS Edge";
    if (agent.includes("opr")) return "Opera";
    if (agent.includes("chrome")) return "Chrome";
    if (agent.includes("trident")) return "MS IE";
    if (agent.includes("firefox")) return "Mozilla Firefox";
    if (agent.includes("safari")) return "Safari";

    return "Other";
};

const detectOperatingSystem = (): string => {
    if (agent.includes("android")) return "Android OS";
    if (agent.includes("iphone") || agent.includes("ipad") || agent.includes("like mac"))
        return "iOS";
    if (agent.includes("win")) return "Windows OS";
    if (agent.includes("mac")) return "Macintosh";
    if (agent.includes("linux")) return "Linux OS";

    return "Unknown OS";
};

const detectScreenResolution = (): string => {
    return `${window.screen.width}x${window.screen.height}`;
};

const detectBrowserVersion = (): string => {
    let match =
        agent.match(/edg\/([\d.]+)/i) ||
        agent.match(/chrome\/([\d.]+)/i) ||
        agent.match(/firefox\/([\d.]+)/i) ||
        agent.match(/version\/([\d.]+).*safari/i) ||
        agent.match(/msie\s([\d.]+)/i) ||
        agent.match(/trident.*rv:([\d.]+)/i);

    return match ? match[1] : "Unknown";
};

const detectDeviceType = (): "mobile" | "tablet" | "desktop" => {
    const ua = navigator.userAgent;

    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }

    if (
        /mobile|iphone|ipod|android|blackberry|iemobile|kindle|opera m(obi|ini)/i.test(
            ua
        )
    ) {
        return "mobile";
    }

    return "desktop";
};

const copyIdToClipboard = async (id: string, successMessage: string, errorMessage?: string | null) => {
    if (typeof id !== "string" || !navigator.clipboard) return;
    try {
        await navigator.clipboard.writeText(id);
        toast.success(successMessage);
    } catch {
        toast.error(errorMessage || "Cannot write text to clipboard");
    }
};

const common = {
    detectBrowser,
    detectOperatingSystem,
    detectScreenResolution,
    detectBrowserVersion,
    detectDeviceType,
    copyIdToClipboard
};

export default common;